// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar-stack_container__E7ifb","image":"avatar-stack_image__MEk7q","moreImages":"avatar-stack_moreImages__g4orr"};